import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    errorToAPIAccess: false,
    fetched: false,
    isLoadingCar: false,
    loadingMaintenanceParts: false,
    searchByVinInProcessing: false,
    pricesTypes: [],
    catalogs: [],
    families: {},
    params: {},
    paramForRemove: null,
    settedParams: "",
    modifications: [],
    modificationsIsLoading: false,
    ssd: null,
    tmpCarId: null, // using in customerGarage
    carFormTabsId: 0,
    maintenanceParts: [],
    maintenancePartsForCar: {
      customer_id: null,
      customer_car_id: null,
      name: null,
    },
    car: {
      engine: null,
      brand: null,
      catalog_code: null,
      family: null,
      model: null,
      link: null,
      name: null,
      mileage: null,
      customer_id: null,
      vin: null,
      car_number: null,
      image: null,
    },
    cars: [],
    garage: [],
    savingInProgress: false,
    selectedModificationProps:null,//свойства модификации выбранной в компоненте CarSelectorByApi
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + "/garage", payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          updateField(state, {
            path: "car",
            value: {
              brand: null,
              catalog_code: null,
              family: null,
              model: null,
              link: null,
              vin: null,
              car_number: null,
              image: null,
              customer_id: null,
            },
          });
          return response.data.id;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getCar({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isLoadingCar", value: true });
      return await axios
        .get(this._vm.$apiURL + "/garage/" + payload.id)
        .then((response) => {
          updateField(state, { path: "isLoadingCar", value: false });
          updateField(state, { path: "car", value: response.data.car });
          return response.data.car;
        })
        .catch((error) => {
          updateField(state, { path: "isLoadingCar", value: false });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    updateCar({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isLoadingCar", value: true });
      return axios
        .put(this._vm.$apiURL + "/garage/" + payload.id, state.car)
        .then((response) => {
          updateField(state, { path: "isLoadingCar", value: false });
          return response.data.car;
        })
        .catch((error) => {
          updateField(state, { path: "isLoadingCar", value: false });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    getGarage({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      axios
        .get(this._vm.$apiURL + "/garage")
        .then((response) => {
          updateField(state, { path: "fetched", value: true });
          updateField(state, { path: "garage", value: response.data });
        })
        .catch((error) => {
          updateField(state, { path: "fetched", value: true });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async getCustomerCars({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + "/garage/customer/" + payload)
        .then((response) => {
          updateField(state, { path: "fetched", value: true });
              if (response.data.status === "success") {
                updateField(state, {path: "cars", value: response.data.data});
                return response.data.data;
              }
        })
        .catch((error) => {
          updateField(state, { path: "fetched", value: true });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    maintenanceParts({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "maintenancePartsForCar",
        value: payload.car,
      });
      updateField(state, { path: "maintenanceParts", value: [] });
      updateField(state, { path: "loadingMaintenanceParts", value: true });
      axios
        .get(
          this._vm.$apiURL +
            "/maintenance_parts?method=maintenance_parts&modif_link=" +
            payload.link +
            "&brand=" +
            payload.brand
        )
        .then((response) => {
          if (response.data.meta) {
            response.data.meta.brand = payload.brand;
          }
          updateField(state, {
            path: "maintenanceParts",
            value: response.data.result,
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally((error) => {
          updateField(state, { path: "loadingMaintenanceParts", value: false });
        });
    },
    async carRemove({ commit, state, dispatch }, payload) {
      return await this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then(async (y) => {
          updateField(state, { path: "isLoadingCar", value: true });
          return await axios
            .delete(this._vm.$apiURL + "/garage/" + payload.id)
            .then((response) => {
              if (response.data.status === "success") {
                dispatch("getGarage");
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                return true;
              }
              updateField(state, { path: "isLoadingCar", value: false });
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
              updateField(state, { path: "isLoadingCar", value: false });
            });
        })
        .catch((n) => {});
    },
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "errorToAPIAccess", value: false });
      return await axios
        .get(this._vm.$apiURL + "/garage/oem-api", { params: payload })
        .then((response) => {
          if (response.data && Object.keys(response.data).length === 0){
            throw `Error Find Vin`;
          }
          if (
            response.data &&
            response.data.error &&
            response.data.error != "" &&
            response.data.error != null
          ) {
            throw `OEM API error: ${response.data.error}`;
          }
          switch (payload.method) {
            case "CatalogsListGet":
              updateField(state, {
                path: "catalogs",
                value: response.data.catalogs,
              });
              updateField(state, { path: "params", value: {} });
              break;
            case "ModelsListGet2":
              updateField(state, {
                path: "families",
                value: response.data.families,
              });
              updateField(state, { path: "params", value: {} });
              updateField(state, { path: "ssd", value: "" });
              break;
            case "VehicleParamsSet":
              updateField(state, {
                path: "params",
                value: response.data.params,
              });
              updateField(state, {
                path: "ssd",
                value: response.data.client.ssd,
              });
              break;
            case "VehicleModificationsGet":
              updateField(state, {
                path: "car.image",
                value: response.data.model_image,
              });
              updateField(state, { path: "modifications", value: [] });
              updateField(state, {
                path: "modifications",
                value: response.data.modifications,
              });
              updateField(state, {
                path: "modificationsIsLoading",
                value: false,
              });
              updateField(state, { path: "paramForRemove", value: null });
              break;
            case "VinFind":
            case "FrameFind":
              let car = {
                image:
                  response.data.image && response.data.image !== ""
                    ? response.data.image
                    : this._vm.$imgDummyPath,
                brand: response.data.client.mark,
                catalog_code: response.data.client.catalog_code,
                family: response.data.client.family,
                model: response.data.client.model,
                vin: payload.vin ? payload.vin : payload.frame,
              };
              updateField(state, {
                path: "searchByVinInProcessing",
                value: false,
              });
              updateField(state, { path: "car", value: car });
              updateField(state, {
                path: "modifications",
                value: response.data.models,
              });
              updateField(state, {
                path: "modificationsIsLoading",
                value: false,
              });
              return car
              break;
          }
          //updateField(state, { path: "pricesTypes", value: response.data });
          return true
        })
        .catch((error) => {
          if(payload.method!=="VinFind" && payload.method!=="FrameFind"){
            updateField(state, { path: "errorToAPIAccess", value: true });
          }
          updateField(state, { path: "searchByVinInProcessing", value: false });
          updateField(state, { path: "modificationsIsLoading", value: false });
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        });
    },
  },
};
